import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowLeft, Download, Sparkles } from 'lucide-react';
import type { IPolicyFormHeaderProps } from '@/@types/insurance';

export function PolicyFormHeader({
  isEditing,
  isSubmitting,
  policyNumber,
  isImported,
  hasCertificateData,
  showCertificateDownload,
  onBack,
  onCancel,
  onSave,
  onDownloadCertificate,
}: IPolicyFormHeaderProps) {
  return (
    <div className="sticky top-0 z-10 py-3 mb-4 bg-background-secondary/95 backdrop-blur-sm border-b border-border flex items-center justify-between px-4">
      <div className="flex items-center gap-4">
        <Button
          variant="outline"
          size="icon"
          onClick={onBack}
          className="shrink-0 rounded-lg w-9 h-9"
          aria-label="Go back"
        >
          <ArrowLeft className="w-[18px] h-[18px]" />
        </Button>
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <h1 className="text-2xl font-bold text-foreground">
              {isEditing ? 'Edit Policy' : 'New Policy'}
            </h1>
            {isImported && (
              <Badge variant="secondary" className="gap-1">
                <Sparkles className="w-3 h-3" />
                Imported
              </Badge>
            )}
          </div>
          <p className="text-sm text-muted-foreground">
            {isEditing ? `Editing policy ${policyNumber ?? ''}` : 'Create a new insurance policy'}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        {isEditing && showCertificateDownload && (
          <Button
            variant="outline"
            className="rounded-lg px-5"
            onClick={onDownloadCertificate}
            disabled={!hasCertificateData}
          >
            <Download className="mr-2 h-4 w-4" aria-hidden="true" />
            Download Certificate
          </Button>
        )}
        <Button
          variant="outline"
          className="rounded-lg px-5"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
        <Button className="rounded-lg px-5" onClick={onSave} disabled={isSubmitting}>
          {isSubmitting ? 'Saving...' : isEditing ? 'Save Changes' : 'Save Policy'}
        </Button>
      </div>
    </div>
  );
}
